import { FolderSimplePlus } from "@phosphor-icons/react";
import { getFileIconBySize } from "./fileUtils";

const folderKey = (folder) => folder?.unique_id || (folder?.id ? `F${folder.id}` : undefined);

export function convertData(TreeData) {
    // Helper function to process each folder and its children
    function processFolder(folder) {
      const result = [];
      // Process subfolders and documents inside the folder
      if (folder?.subfolders?.length > 0) {
        for (const subFolder of folder.subfolders) {
          result.push({
            title: subFolder.name,
            id:subFolder.id,
            // key: generateUUID(),
            key:folderKey(subFolder),
            record:subFolder,
            relativePath:subFolder.relative_path,
            is_highlighted :subFolder.is_highlighted,
            type:"folder",
            icon: <FolderSimplePlus size={18} color="#5A6C87"/>,
            children: (subFolder.subfolders.length> 0 ||subFolder.documents.length> 0) ? processFolder(subFolder):[{}] // Recursively process subfolders
          });
        };
      }
  
      // Process documents in the folder
      if (folder.documents.length >0) {
       for (const document of folder.documents) {
          result.push({
            title: document.name,
            id:document.id,
            // key: generateUUID(),
            key:document.unique_id,
            record:document,
            type:"document",
            relativePath:document.relative_path,
            is_highlighted :document.is_highlighted,
            icon: getFileIconBySize(document.name, "document", 18),
          });
        };
      }
  
      return result;
    }
  
    const transformed = [];
    // Skip the root matter1 and directly process its folders
    for (const item of TreeData) {
      if (item.folders) {
       for (const folder of item.folders) {
          transformed.push({
            title: folder.name, // Use folder name as title
            // key: generateUUID(),     // Use folder id as key
            icon: <FolderSimplePlus size={18} color="#5A6C87"/>,
            id:folder.id,
            record:folder,
            key:folderKey(folder),
            relativePath:folder.relative_path,
            is_highlighted :folder.is_highlighted,
            type:"folder",
            children: processFolder(folder).length ===0 ?[{}] :processFolder(folder)  // Recursively process subfolders and documents
          });
        };
      }
      if (item.documents) {
          for (const folder of item.documents) {
          transformed.push({
            title: folder.name, // Use folder name as title
            // key: generateUUID(),
            key:folder.unique_id,
            id:folder.id,
            record:folder,
            relativePath:folder.relative_path,
            is_highlighted :folder.is_highlighted,
            type:"document",
            icon: getFileIconBySize(folder.name, "document", 18),
          });
        };
      }
    };
  
    return transformed;
  }
  